import { render, staticRenderFns } from "./FaceMergeForm.vue?vue&type=template&id=d74aaf20&scoped=true"
import script from "./FaceMergeForm.vue?vue&type=script&lang=js"
export * from "./FaceMergeForm.vue?vue&type=script&lang=js"
import style0 from "./FaceMergeForm.vue?vue&type=style&index=0&id=d74aaf20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74aaf20",
  null
  
)

export default component.exports